import _ from 'lodash';

export default ({ store }) => {
    const setInnerWidth = (e) => {
        store.commit('setVw', e.target.innerWidth);
    };
    window.onresize = _.debounce(setInnerWidth, 100);
};
